import React from 'react'
import { CardInfo } from '../../../../../Portfolio_R/SummaryCharts/components/CardInfo'

interface Props {
    styleContent: string;
    principalTitle: string;
    generalData: any;
}

const TitlesAndValuesCard: React.FC<Props> = ({ styleContent, principalTitle, generalData }) => {
    return (
        <div className={styleContent}>
            <div className='c-approve-projects-content'>
                <div>
                    <h3 className="chart-title">{principalTitle}</h3>
                </div>

                <div className="chart-content">
                    {generalData.map(({ title, data, units = '', description }, index) => {
                        return (
                            <CardInfo
                                key={`${title}-${index}`}
                                title={title}
                                data={data}
                                units={units}
                                description={description}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default TitlesAndValuesCard
